import LogoMarkGreyscale from "graphics/Branding/LogoMarkGreyscale";
import React from "react";

const StartOfEffice = () => {
  return (
    <div className="Txt-effice-start">
      <LogoMarkGreyscale />
    </div>
  );
};

export default StartOfEffice;
